import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import { DictEntryModel } from '../models/dict-entry.model';
import { SearchService } from '../services/search.service';
import { ISearchService } from '../services/ISearchService';
import { HistorySearchService } from '../services/history-search.service';
import { WordSearchService } from "../services/word-search.service";
import {NavigationEnd, Router} from "@angular/router";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit, OnChanges, OnDestroy {

  @Output()
  selected = new EventEmitter<{ query: string; word: string }>();

  @Input()
  headSearchService: ISearchService;

  @Input()
  query = '';

  @Input()
  home = false;

  results: string[] = [];
  searchTerm = '';
  word: DictEntryModel = {} as DictEntryModel;
  suggestions: string[] = [];
  routerSubscription: Subscription;

  constructor(
    private searchService: SearchService,
    private historySearchService: HistorySearchService,
    private wordSearchService: WordSearchService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.headSearch(this.query)
      }
    });
    // this.headSearch(this.query);
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.query && changes.query.currentValue) {
      this.query = changes.query.currentValue;
      this.headSearch(this.query);
    }
  }

  headSearch(term: string) {
    term = term.trim();
    this.suggestions = [];
    this.query = term;
    if (this.home && term === '') {
      this.historySearchService.search(term).subscribe(results => {
        if (results.length < 10) {
          this.wordSearchService.random().subscribe(headResults => {
            this.results = [...results, ...headResults];
          });
        } else {
          this.results = results
        }
      })
    } else {
      this.headSearchService.search(term).subscribe(results => {
        this.results = results;
        if (results.length === 0) {
          this.suggestionSearch(term);
        }
      });
    }
  }

  suggestionSearch(term: string) {
    term = term.trim();
    this.searchService.suggestions(term).subscribe(results => {
      let suggestions = [];
      if (results?.headwords) {
        suggestions = suggestions.concat(results.headwords);
      }
      this.searchService.spellSuggestions(term).subscribe(spellSuggestions => {
        if (spellSuggestions?.suggestions) {
          suggestions = suggestions.concat(spellSuggestions.suggestions);
        }
        this.suggestions = suggestions;
      }, error => {
        this.suggestions = suggestions;
      });
    });
  }

  showMorphResult(term: string) {
    term = term.trim();
    this.selected.emit({ query: term, word: '' });
  }

  selectWord(word: string) {
    this.selected.emit({ query: this.query, word });
  }

}
